import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaUsers, FaRocket, FaAward, FaHeart } from 'react-icons/fa';
import './AboutPreview.css';

const AboutPreview = () => {
  const stats = [
    { icon: <FaUsers />, value: '50+', label: 'Team Members' },
    { icon: <FaRocket />, value: '100+', label: 'Projects Delivered' },
    { icon: <FaAward />, value: '15+', label: 'Awards Won' },
    { icon: <FaHeart />, value: '98%', label: 'Client Satisfaction' }
  ];

  return (
    <section className="about-preview">
      <div className="container">
        <div className="about-grid">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="about-content"
          >
            <span className="section-subtitle">Who We Are</span>
            <h2 className="about-title">
              We're on a Mission to <span className="gradient-text">Transform</span> Businesses Through Technology
            </h2>
            <p className="about-description">
              At ZustandTech, we believe in the power of technology to solve complex problems 
              and create amazing experiences. Founded in 2020, we've grown from a small team 
              of passionate developers to a full-service software development company.
            </p>
            <p className="about-description">
              Our team combines technical expertise with creative thinking to deliver solutions 
              that not only meet but exceed client expectations. We're not just building software; 
              we're building partnerships that last.
            </p>

            <div className="about-features">
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Innovative Solutions</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Client-Centric Approach</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Agile Development</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>24/7 Support</span>
              </div>
            </div>

            <Link to="/about" className="btn btn-primary">
              Learn More About Us <FaArrowRight />
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="about-visual"
          >
            <div className="about-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
                alt="Team collaboration"
                className="about-image"
              />
              <div className="experience-badge">
                <span className="years">5+</span>
                <span className="text">Years of Excellence</span>
              </div>
            </div>

            <div className="stats-grid">
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="stat-card"
                >
                  <div className="stat-icon">{stat.icon}</div>
                  <div className="stat-info">
                    <span className="stat-value">{stat.value}</span>
                    <span className="stat-label">{stat.label}</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;